import { createSlice } from "redux-starter-kit";

const initialState = {
  notifications: [],
};

export const miscSlice = createSlice({
  slice: "misc",
  initialState: initialState,
  reducers: {
    set: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    toggle: (state, action) => {
      const { key } = action.payload;
      state[key] = !state[key];
    },
    push: (state, action) => {
      const { key, value } = action.payload;
      state[key] = state[key] ? [...state[key], value] : [value];
    },
    removeElement: (state, action) => {
      const { key, value, field } = action.payload;
      state[key] = state[key] && state[key].length ? state[key].filter((i) => i[field] !== value) : [];
    },
  },
});
